import { useDispatch, useSelector, useStore } from 'react-redux';

import type { Store } from 'redux';

import type { AppDispatch, BaseAppState } from './types';

// biome-ignore lint/plugin: react-redux's useDispatch.withTypes() cannot express the app's custom callable AppDispatch type, so this boundary cast is required.
export const useAppDispatch = useDispatch.withTypes() as () => AppDispatch;
export const useAppSelector = useSelector.withTypes<BaseAppState>();
export const useAppStore = useStore.withTypes<Store<BaseAppState>>();
